import personImageSrc from 'components/OnePageTemplates/mockData/personPhoto.jpg';

import { ReactComponent as MockLogoWhite } from '../mockData/mockLogoWhite.svg';

export const EXAMPLE_DOC_ES = {
  companyLogo: <MockLogoWhite />,
  companyName: 'Agrotech',
  projectBriefDescription:
    'Desarrollo de trigo resistente al frío mediante investigación, ensayos de campo y escalado de la producción. Mercado objetivo: sector agrícola y productores de trigo. Objetivo de la financiación: afrontar los desafíos climáticos y contribuir a la seguridad alimentaria.',
  lifeCycleStage: 'R&D',
  annualIncome: '$65,000,000',
  projectPaybackPeriod: '3 meses',
  forecastedProfitability: '15%',
  fundingAmount: '$65,000,000',
  totalCost: '$65,000,000',
  percentageOfFunding: '30%',
  companyBriefDescription:
    'Empresa líder estadounidense de biotecnología agrícola especializada en la investigación, el desarrollo y la comercialización de variedades innovadoras de cereales. La compañía desarrolla soluciones de vanguardia para responder a las necesidades cambiantes de los agricultores y de la industria alimentaria. Mediante técnicas avanzadas de biología molecular y mejora genética, crea variedades de alto rendimiento con mayor productividad, resistencia a enfermedades y capacidad de adaptación a diferentes condiciones climáticas.',
  operatingIndustry: 'Investigación, desarrollo y comercialización de variedades innovadoras de cultivos de cereales',
  registrationDate: '11.11.2002',
  numberOfEmployees: '150',
  mainGoals:
    'Desarrollar variedades de trigo resistentes al frío, impulsar la investigación, ampliar la capacidad de producción y promover una agricultura sostenible. Estrategias clave: inversión en I+D, colaboración estratégica, expansión del mercado y seguimiento continuo del rendimiento.',
  strategyForAchievingGoals:
    'El desarrollo de cereales con una mayor resistencia al frío permitirá a los agricultores disponer de cultivos más sólidos y adaptables. Estas variedades han sido diseñadas para soportar temperaturas extremadamente bajas, garantizando mejores tasas de supervivencia y un crecimiento estable incluso en condiciones invernales adversas. Esta innovación busca reducir el impacto del clima sobre la producción agrícola, aumentar los rendimientos, fortalecer la estabilidad económica de los productores y reforzar la seguridad alimentaria.',
  mainProductsOrServices:
    'La empresa está especializada en variedades de trigo resistentes al frío que permiten a los agricultores obtener cosechas fiables incluso en climas extremos. Actualmente ofrece la Variedad de Trigo 1 para zonas de bajas temperaturas y prevé lanzar la Variedad de Trigo 2 con un nivel de resistencia al frío aún mayor.',
  competitionAdvantage:
    'El proyecto integra investigación científica, validación mediante ensayos de campo y escalado industrial para desarrollar trigo resistente al frío. Su propuesta de valor responde a los desafíos del cambio climático y contribuye a garantizar la seguridad alimentaria mediante soluciones agrícolas innovadoras.',
  targetMarket:
    'El mercado objetivo está compuesto por explotaciones dedicadas al cultivo de trigo en Dakota del Sur y Dakota del Norte. En 2022, Dakota del Sur produjo 4 millones de toneladas de trigo y Dakota del Norte 4,2 millones. El valor conjunto de este mercado se estima en 103.000 millones de dólares. Ese mismo año existían 20.501 explotaciones agrícolas dedicadas al trigo en Dakota del Sur y 21.003 en Dakota del Norte.',
  mainCompetitors:
    'Más de 120 empresas compiten en el mercado del suministro de trigo. American AGRO lidera el sector con una cuota de mercado del 15 %. Entre los principales competidores también se encuentran EcoWheat y Grain Processing Corporation.',
  targetChannels:
    'Los clientes objetivo incluyen 41.505 pequeños y medianos productores de trigo en Dakota del Sur y Dakota del Norte. El perfil principal corresponde a agricultores de entre 20 y 50 años que gestionan explotaciones de tamaño pequeño o mediano y buscan variedades de trigo resistentes a condiciones climáticas extremas y compatibles con prácticas agrícolas sostenibles.',
  revenueStreams:
    'Las principales fuentes de ingresos incluyen la venta de semillas genéticamente modificadas, acuerdos de licencia de propiedad intelectual y servicios de consultoría para el desarrollo de cultivos. Los supuestos financieros clave contemplan la demanda del mercado, el éxito de las actividades de I+D, la adopción por parte de los agricultores, las aprobaciones regulatorias y la eficiencia operativa. Entre los socios estratégicos figuran instituciones de investigación, asociaciones agrícolas, distribuidores de semillas y organismos reguladores que impulsan la innovación, la expansión comercial y el cumplimiento normativo.',
  marketingStrategy:
    'Minoristas y cooperativas agrícolas, plataformas digitales de comercio electrónico, distribuidores mayoristas de semillas',
  projectStatus: ['Research and Development'],
  team: 'El equipo principal del proyecto está integrado por Edward Lando — Director Ejecutivo (CEO), Naval Ravikant — Director Financiero (CFO) y Fabrice Grinda — Científico Principal.',
  dynamics:
    'La superficie agrícola en Dakota del Sur y Dakota del Norte aumenta en aproximadamente 2.000 hectáreas al año. Se prevé que el mercado crezca a una tasa compuesta anual (CAGR) del 4 % entre 2022 y 2030, impulsado por los avances tecnológicos y un entorno regulatorio favorable para los cultivos modificados genéticamente.',
  problemOfMarket:
    'Los productores de cereales en Estados Unidos afrontan importantes desafíos debido a la creciente frecuencia de inviernos extremos e impredecibles. La limitada resistencia de las variedades tradicionales al frío provoca menores rendimientos, pérdidas de cosechas y un impacto económico significativo para los agricultores. Esta vulnerabilidad compromete la estabilidad y la productividad del mercado estadounidense de cereales.',
  projectedAnnualIncome: '65000000',
  projectedAnnualProfit: '65000000',
  returnOnInvestment: '20',
  internalRateOfReturn: '25',
  teamMembers: [
    {
      fullName: 'Edward Lando',
      position: 'Director Ejecutivo (CEO)',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Universidad Estatal de Oklahoma, Finanzas',
      workExperience:
        'Abril de 2017 — Mayo de 2020, ARP Dend, Gerente Financiero\nResponsable del desarrollo y mantenimiento de modelos financieros para proyectar el desempeño económico de la empresa. Analizó datos financieros para identificar tendencias en ingresos, estructuras de costos y rentabilidad. Evaluó los riesgos financieros y diseñó estrategias para mitigarlos.',
      keySkills: 'Resolución de problemas',
      achievements:
        'Lideró la expansión de la empresa hacia 12 nuevos mercados, logrando un incremento del 40 % en los ingresos globales.',
    },
    {
      fullName: 'Edward Lando',
      position: 'Director Ejecutivo (CEO)',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Universidad Estatal de Oklahoma, Finanzas',
      workExperience:
        'Abril de 2017 — Mayo de 2020, ARP Dend, Gerente Financiero\nResponsable del desarrollo y mantenimiento de modelos financieros para proyectar el desempeño económico de la empresa. Analizó datos financieros para identificar tendencias en ingresos, estructuras de costos y rentabilidad. Evaluó los riesgos financieros y diseñó estrategias para mitigarlos.',
      keySkills: 'Resolución de problemas',
      achievements:
        'Lideró la expansión de la empresa hacia 12 nuevos mercados, logrando un incremento del 40 % en los ingresos globales.',
    },
    {
      fullName: 'Edward Lando',
      position: 'Director Ejecutivo (CEO)',
      photoSrc: personImageSrc,
      dateOfBirth: '02.05.1983',
      education: 'Universidad Estatal de Oklahoma, Finanzas',
      workExperience:
        'Abril de 2017 — Mayo de 2020, ARP Dend, Gerente Financiero\nResponsable del desarrollo y mantenimiento de modelos financieros para proyectar el desempeño económico de la empresa. Analizó datos financieros para identificar tendencias en ingresos, estructuras de costos y rentabilidad. Evaluó los riesgos financieros y diseñó estrategias para mitigarlos.',
      keySkills: 'Resolución de problemas',
      achievements:
        'Lideró la expansión de la empresa hacia 12 nuevos mercados, logrando un incremento del 40 % en los ingresos globales.',
    },
  ],
  contacts: {
    websiteUrl: 'agrotech.com',
    phone: '1(062)7266363',
    email: 'office@agrotech.com',
    fullNameWithPos: 'John Doe, Director Ejecutivo (CEO)',
    address: '699 Walnut St. Suite 1800, Des Moines, IA 50309, Estados Unidos.',
  },
  financingNeedsChart: {
    otherCost: { percentage: '8.333333333333332', currencyAmount: '50' },
    researchCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    equipmentCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    marketingCost: { percentage: '16.666666666666664', currencyAmount: '100' },
    constructionCost: { percentage: '25', currencyAmount: '150' },
    workingCapitalCost: { percentage: '16.666666666666664', currencyAmount: '100' },
  },
  implementationPlanStages: [
    {
      stage: 'Planificación de investigación y desarrollo (I+D)',
      from: '2024-01-05T21:00:00.000Z',
      to: '2024-02-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Realizar el análisis inicial de resistencia al frío',
      from: '2024-02-05T21:00:00.000Z',
      to: '2024-03-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Desarrollar estrategias de modificación genética (si corresponde)',
      from: '2024-03-05T21:00:00.000Z',
      to: '2024-05-05T21:00:00.000Z',
      status: {
        value: 'Done',
        label: 'Done',
      },
    },
    {
      stage: 'Selección y adquisición de semillas',
      from: '2024-04-05T21:00:00.000Z',
      to: '2024-08-05T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Establecer campos de prueba',
      from: '2024-07-05T21:00:00.000Z',
      to: '2024-07-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Sembrar variedades de trigo resistentes al frío',
      from: '2024-07-05T21:00:00.000Z',
      to: '2024-07-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Analizar los resultados y optimizar la solución',
      from: '2024-08-05T21:00:00.000Z',
      to: '2024-08-25T21:00:00.000Z',
      status: {
        value: 'In progress',
        label: 'In Progress',
      },
    },
    {
      stage: 'Escalado de la producción',
      from: '2024-09-05T21:00:00.000Z',
      to: '2024-10-05T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
    {
      stage: 'Desarrollar la estrategia de marketing y ventas',
      from: '2024-10-05T21:00:00.000Z',
      to: '2024-12-05T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
    {
      stage: 'Lanzamiento del producto',
      from: '2024-12-05T21:00:00.000Z',
      to: '2024-12-25T21:00:00.000Z',
      status: {
        value: 'To do',
        label: 'To Do',
      },
    },
  ],
};
